import React from 'react';

import { isEmpty } from 'lodash';

import clsx from 'clsx';

import ValueConfigurationListBox from './ValueConfigurationListBox';

import * as classes from './ValueConfigurationInsert.module.css';

const ValueConfigurationInsert = ({
    selectedAttribute,
    selectedEntity,
    items,
    setItems,
    ...props
}) => {

    return (
        <div className={classes.ValueConfigurationInsert}>
            {
                isEmpty(selectedAttribute) || isEmpty(selectedEntity) ?
                    <div className={classes.ErrorContainer}>
                        <span className={clsx('material-icons-outlined md-18', classes.ErrorIcon)}>
                            error_outline
                        </span>
                        <span className={classes.ErrorText}>Please select an Attribute and Entity to proceed.</span>
                    </div>
                    :
                    <div>
                        <ValueConfigurationListBox
                            items={items}
                            setItems={setItems}
                            selectedAttribute={selectedAttribute}
                            selectedEntity={selectedEntity}
                        />
                    </div>
            }
        </div>
    );
};

export default ValueConfigurationInsert;
